module.exports = __webpack_public_path__ + "media/images/eu-co-fund-31c9e383b25a3bca91fcbbc5bae5ca82.png";